import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: () => import("../views/home.vue"),
        redirect: 'home'
    },
    {
        path: "/home",
        name: "Home",
        component: () => import("../views/home.vue"),
        meta: { title: "首页" }

    },
    {
        path: "/room",
        name: "Room",
        component: () => import("../views/room.vue"),
        meta: { title: "房间" }
    },
    // {
    //     path: "/onlyOffice",
    //     name: "onlyOffice",
    //     component: () => import("../views/onlyOffice.vue"),
    //     meta: { title: "在线文档" }
    // },
    {
        path: "/test",
        name: "test",
        component: () => import("../views/test.vue"),
        meta: { title: "test" }
    },
    {
        path: "/testRoom",
        name: "testRoom",
        component: () => import("../views/testRoom.vue"),
        meta: { title: "testRoom" }
    },
    {
        path: "/sign",
        name: "signFor",
        component: () => import("../views/signFor.vue"),
        meta: { title: "signFor" }
    }
]

const router = new VueRouter({
    routes,
})

export default router